<!--
  Component: MetricAltAssess

  This component creates a description of ELA and Math NYSAA scores for D75 schools.

  Notes:
  - Valid slot names: {ela|math}_value_{1|2|3|4}
-->
<template>
  <div class="metric-alt-assess">
    <div v-for="e in examTypes" :key="e" class="score-group">
      <h5 class="title">{{e}}:</h5>
      <ul class="score-group-content">
        <li v-for="n in levelOrder" :key="n">Level {{n}} - {{valueForExamLevel(e,n)}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import Component from 'vue-class-component'

import MetadataBase from './MetadataBase'

@Component({
})
export default class MetricAltAssess extends MetadataBase {
  examTypes = ['ELA', 'Math']
  levelOrder = [4, 3, 2, 1]

  /* Methods - utility */

  valueForExamLevel (exam, level) {
    return this.valueForSlotName(exam.toLowerCase() + '_value_' + level)
  }
}
</script>

<style lang="scss">
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.score-group {
  display: inline-block;
  width: 180px;
  padding-right: 24px;
  > * {
    display: inline-block;
    margin: 0px;
  }
  .title {
    vertical-align: top;
    text-align: right;
    width: 54px;
    padding-right: 14px;
  }
  .score-group-content {
    padding-bottom: 1.2em;
    padding-inline-start: 0px;
    > li {
      list-style-type: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sqs/2025/tab-mods/MetricAltAssess.vue